import React from "react";

export default function DrawnPatternsCount({ count }) {
  return (
    <div style={{ textAlign: "center" }}>{`${count} pattern${
      count === 1 ? "" : "s"
    } drawn`}</div>
  );
}
